/**
 * Where the bare root `/` sends the signed-in user (views/home.vue). Pure so it is tested
 * (landing.test.ts): the frontend has no @vue/test-utils to mount the view.
 */
import { PERMISSION_EXAM_SUPERVISION } from '@/utils/exam-supervision-feature';
import { PERMISSION_SPECIALIST_FOLLOW_UP, SPECIALIST_DASHBOARD_PATH } from '@/utils/specialist-feature';

const PERMISSION_ENSEIGNANT = 'Parcours.LearningModule.Enseignant';

/** The teacher's landing: their section dashboard. */
export const TEACHER_LANDING_PATH = '/enseignement/tableau-de-bord';

/**
 * The exam supervisor's landing (#1164): the Présences sheet, which locks itself into the
 * supervisor mode for them — or says « Fonctionnalité désactivée » when the flag is off.
 */
export const SUPERVISOR_LANDING_PATH = '/enseignement/presences';

/**
 * The student's landing. The schedule works for individual and group enrolments alike, so it is
 * the stable one; Assignations remains one click away for students who can record drafts.
 */
export const STUDENT_LANDING_PATH = '/enseignement/mon-horaire';

/**
 * Permission-only, with no flag read: with the flag off the supervisor still lands on Présences,
 * where the page says why there is nothing to record, rather than on a screen that answers 403.
 */
export function resolveDestination(permissions: readonly string[]): string {
  if (permissions.includes(PERMISSION_ENSEIGNANT)) return TEACHER_LANDING_PATH;
  // The « Surveillant d'examen » holds no Enseignant, and used to fall through to the student
  // schedule below — which answers them 403. Présences is the only screen they have.
  if (permissions.includes(PERMISSION_EXAM_SUPERVISION)) return SUPERVISOR_LANDING_PATH;
  // The « Spécialiste » outside the Enseignant roster (#1226): their own section is all they have
  // (#1445), opened on its dashboard; the student schedule below would answer them 403. With the
  // flag off, the route guard sends them on to the teacher dashboard.
  if (permissions.includes(PERMISSION_SPECIALIST_FOLLOW_UP)) return SPECIALIST_DASHBOARD_PATH;
  return STUDENT_LANDING_PATH;
}
